<template>
    <div class="min-h-screen bg-gray-100">
        <nav class="bg-white border-b border-gray-100">
            <!-- Primary Navigation Menu -->
            <div class="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
                <div class="flex justify-between h-16">
                    <div class="flex">
                        <!-- Logo -->
                        <div class="flex items-center flex-shrink-0">
                            <a href="/admin/dashboard">
                                <app-logo width="60px" />
                            </a>
                        </div>

                        <!-- Navigation Links -->
                        <div class="hidden space-x-8 sm:-my-px sm:ml-10 sm:flex">
                            <AdminLink v-if="false" to="/admin/dashboard" name="Ülevaade"/>
                            <AdminLink to="/admin/projects" name="Projektid"/>
                            <AdminLink to="/admin/users" name="Kasutajad"/>
                            <AdminLink to="/admin/config" name="Seaded"/>
                            <AdminLink v-if="false" to="/admin/tasks" name="Tegevused"/>
                            <AdminLink to="/admin/contracts" name="Lepingud"/>
                            <AdminLink to="/projects" name="Tagasi tavavaatesse"/>
                        </div>
                    </div>

                    <!-- Settings Dropdown -->
                    <div class="hidden sm:flex sm:items-center sm:ml-6">
                        <div class="relative ml-3">
                            <jet-dropdown align="right" width="48">
                                <template #trigger>
                                    <button
                                        class="flex text-sm transition duration-150 ease-in-out border-2 border-transparent rounded-full focus:outline-none focus:border-gray-300"
                                    >
                                        <img
                                            class="object-cover w-8 h-8 rounded-full"
                                            :src="user.profile_photo_url"
                                            :alt="user.name"
                                        />
                                    </button>
                                </template>

                                <template #content>
                                    <!-- Account Management -->
                                    <div class="block px-4 py-2 text-xs text-gray-400">Manage Account</div>

<!--                                    <div class="ml-3"><AdminLink name="Profile" to="/user/profile"/></div>-->

                                    <div class="border-t border-gray-100"></div>

                                    <!-- Authentication -->
                                    <form @submit.prevent="logout">
                                        <jet-dropdown-link as="button"> Logout</jet-dropdown-link>
                                    </form>
                                </template>
                            </jet-dropdown>
                        </div>
                    </div>

                    <!-- Hamburger -->
                    <div class="flex items-center -mr-2 sm:hidden">
                        <button
                            @click="showingNavigationDropdown = !showingNavigationDropdown"
                            class="inline-flex items-center justify-center p-2 text-gray-400 transition duration-150 ease-in-out rounded-md hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500"
                        >
                            <svg class="w-6 h-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                                <path
                                    :class="{ hidden: showingNavigationDropdown, 'inline-flex': !showingNavigationDropdown }"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M4 6h16M4 12h16M4 18h16"
                                />
                                <path
                                    :class="{ hidden: !showingNavigationDropdown, 'inline-flex': showingNavigationDropdown }"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M6 18L18 6M6 6l12 12"
                                />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>

            <!-- Responsive Navigation Menu -->
            <div
                :class="{ block: showingNavigationDropdown, hidden: !showingNavigationDropdown }"
                class="sm:hidden"
            >
                <div class="pt-2 pb-3 space-y-1">
                    <jet-responsive-nav-link href="/admin/dashboard" :active="currentRoute == 'dashboard'">
                        Ülevaade
                    </jet-responsive-nav-link>
                </div>

                <!-- Responsive Settings Options -->
                <div class="pt-4 pb-1 border-t border-gray-200">
                    <div class="flex items-center px-4">
                        <div class="flex-shrink-0">
                            <img
                                class="w-10 h-10 rounded-full"
                                :src="user.profile_photo_url"
                                :alt="user.name"
                            />
                        </div>

                        <div class="ml-3">
                            <div class="text-base font-medium text-gray-800">{{ user.name }}</div>
                            <div class="text-sm font-medium text-gray-500">{{ user.email }}</div>
                        </div>
                    </div>

                    <div class="mt-3 space-y-1">
<!--                        <div class="ml-4"><AdminLink name="Profile" to="/user/profile"/></div>-->
                        <div class="ml-4"><AdminLink name="API Tokens" to="/user/api-tokens"/></div>

                        <!-- Authentication TODO -->
                        <form method="POST" @submit.prevent="logout">
                            <jet-responsive-nav-link as="button"> Logout</jet-responsive-nav-link>
                        </form>
                    </div>
                </div>
            </div>
        </nav>

        <!-- Page Heading -->
        <header class="bg-white shadow">
            <div class="px-4 py-6 mx-auto max-w-7xl sm:px-6 lg:px-8">
                <slot name="header"></slot>
            </div>
        </header>

        <!-- Page Content -->
        <main>
            <transition name="fade" mode="out-in">
                <div key="appSlot">
                    <slot />
                </div>
            </transition>
        </main>

        <!-- Modal Portal -->
        <portal-target name="modal" multiple></portal-target>
        <toast position="top-center" />

        <cookie-accept/>
    </div>
</template>

<script>
import AuthService from '../services/auth.service';
import JetDropdown from './../Jetstream/Dropdown';
import JetDropdownLink from './../Jetstream/DropdownLink';
import JetResponsiveNavLink from './../Jetstream/ResponsiveNavLink';
import AdminLink from '../components/AdminLink';
import CookieAccept from "@/components/CookieAccept";
import { mapGetters } from 'vuex';
import {logout} from "@/store/login.api";

export default {
    components: {
        JetDropdown,
        JetDropdownLink,
        JetResponsiveNavLink,
        AdminLink,
        CookieAccept,
    },

    data() {
        return {
            showingNavigationDropdown: false,
        }
    },

    methods: {
        logout() {
            logout().then((response) => {
                AuthService.clearStorage();
                window.location = '/'
            })
        }
    },

    computed: {
        ...mapGetters({
            user: 'global/user',
            isAdmin: 'global/isAdmin',
        }),
        currentRoute() {
            return this.$route.path.split('/')[this.$route.path.split('/').length - 1];
        },
        path() {
            return window.location.pathname
        }
    }
}
</script>
